import React, { useRef, useEffect,useState,useCallback } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { removeSpinner } from '../../../utilities/function/common'

const SEARCH_DOMAIN_NAME_CLASSNAME = 'of-search-domain-connector'

export const SearchDomainNameConnector = ({button_label,placeholder,router,container,transfer,tld,www,promo}) => {
  const id = makeid(10)
  const search_field = useRef(null)
  const {history} = router
  const getPlaceholder =() =>{
    return placeholder?placeholder:<>Start your search here!</>
  }

  const getButtonText = () =>{
    return button_label?button_label:<i className={'icon icon-of-search'}/>
  }
  const formOnSubmit = (e) => {
    e.preventDefault();
    let domainname = search_field.current.value
    if(domainname){
      if(domainname.indexOf('www.')>-1){
        domainname = domainname.replace('www.','')
      }
      if(tld){
        domainname = domainname.split('.')
        if(Array.isArray(domainname) && domainname.length > 0){
          domainname = domainname[0] + tld
        }
      }
      const promoParams = promo?`&promo=${promo}`:''
      if(transfer){
        history.push(`${history.location.pathname}?a=add&query=${domainname}&domain=transfer${promoParams}`)
      }else{
        history.push(`${history.location.pathname}?a=add&query=${domainname}&domain=register${promoParams}`)
      }
    }
  }
  const renderTLD = () => {
    if(tld){
      return (
        <div className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__tld tld`}>{tld}</div>
      )
    }
    return (<></>)
  }
  const renderWWW = () =>{
    if(www){
      return (
        <div className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__www www`}>www.</div>
      )
    }
    return (<></>)
  }
  useEffect(()=>{
    removeSpinner(container)
  },[container])
  return(
    ReactDOM.createPortal(
      <form onSubmit={formOnSubmit} className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__form clearfix`}>
        <div className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__wrapper clearfix`}>
          {renderWWW()}
          <input id={`${SEARCH_DOMAIN_NAME_CLASSNAME}__field_${id}`} ref={search_field}  type={'text'} className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__field`}  placeholder={getPlaceholder()}/>
          <label className={`of-site-connector__label`} htmlFor={`${SEARCH_DOMAIN_NAME_CLASSNAME}__field_${id}`}>{getPlaceholder()}</label>
          {renderTLD()}
          <button aria-label={`Search Domain`} className={`${SEARCH_DOMAIN_NAME_CLASSNAME}__button${button_label?` ${SEARCH_DOMAIN_NAME_CLASSNAME}__button--label`:''}`} type={'submit'}>{getButtonText()}</button>
        </div>
      </form>
      ,container)
  )
}

SearchDomainNameConnector.propTypes = {
  button_label: PropTypes.string,
  placeholder: PropTypes.string,
  router: PropTypes.any,
  container: PropTypes.object
}

export const RenderSearchDomainNameConnector = (props) => {
  const [update,updateState] = useState(false)
  const {router} = props
  const forceUpdate = useCallback(() => {
    updateState(!update)
  },[update,updateState])
  useEffect(()=>{
    window.updateSearchDomain = forceUpdate
  },[forceUpdate])
  const domlist = Array.from(document.querySelectorAll(`.${SEARCH_DOMAIN_NAME_CLASSNAME}`))
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const button_label = el.getAttribute('data-button-label')
      const placeholder = el.getAttribute('data-placeholder')
      const transfer = el.getAttribute('data-transfer')
      const www = el.getAttribute('data-www')
      const tld = el.getAttribute('data-tld')
      const promo = el.getAttribute('data-promo')
      return (<SearchDomainNameConnector
        button_label={button_label}
        key={index}
        container={el}
        placeholder={placeholder}
        router = {router}
        transfer={transfer}
        www={www}
        tld={tld}
        promo={promo}
      />)
    })
  }
  return (<></>)
}

RenderSearchDomainNameConnector.propTypes ={
  router: PropTypes.object
}

const makeid = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};